import React, { Dispatch, SetStateAction } from 'react';
import classNames from 'classnames';

import './WpToggleButton.scss';

export type WpToggleButtonSizeType = 'sm' | 'md' | 'lg';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;

export interface Props {
  children: React.ReactNode;
  activeTab?: string;
  onTabClick?: Dispatcher<string>;
  tabId: string;
  innerRef?: { current: HTMLDivElement };
}

const WpToggleButton: React.FC<Props> = ({ children, activeTab, tabId = '', onTabClick, innerRef }: Props) => {
  const isActive = activeTab === tabId;

  const classNamePrefix = 'WpToggleButton';
  const classes = classNames(classNamePrefix, isActive ? `${classNamePrefix}--active` : false);

  return (
    <div ref={innerRef} className={classes} onClick={() => onTabClick(tabId)}>
      {children}
    </div>
  );
};

export default WpToggleButton;
